module.exports = __webpack_public_path__ + "img/hospital.d48fb5b2.png";